// Datée de la mise en ligne de l'assistant en langage naturel (sous-traitant
// ultérieur Google Cloud France, Vertex AI en Union européenne).
export const LEGAL_DOCUMENT_VERSION = '15 septembre 2026';

export const LEGAL_SERVICE = {
  name: "Innov'Paie",
  publisher: 'KAZAC',
  publisherTradeName: 'YSO CONSEILS',
  legalForm: 'SAS',
  shareCapital: '100 €',
  registeredOffice: 'Bureau 326, 59 rue de Ponthieu, 75008 Paris',
  siren: '844 924 605',
  siret: '844 924 605 00026',
  registration: 'RCS Paris 844 924 605',
  vatNumber: 'FR91 844 924 605',
  publicationDirector: 'Michel BAKALE',
  contactEmail: 'rose.yemeli@yso-conseils.com',
} as const;
